import { coreAPI } from "../../axios";

export const actions = {
    //ConsolidatedProcurableResource
    GetTotalAllocation(context, data){
        return coreAPI.get(`Dashboard/Data/${data.deliveryUnitId}/${data.campusId}/${data.cycle}`);
    },
    GetProcurementSummary(context, data){
        return coreAPI.get(`Dashboard/ProcurementSummary/${data.fsId}/${data.cycle}`);
    },
    GetItemRequests(context, data){
        return coreAPI.get(`Dashboard/Pending/ItemRequests/${data}`);
    },
    GetMenuCounts(context, data){
        return coreAPI.get(`Dashboard/ActionCounter/${data.deliveryUnitId}/${data.campusId}/${data.cycle}`);
    }
}